import { Divider, Grid } from '@mui/material'
import { lazy, Suspense, useContext } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss"; 
import interactionAndCampaignsStyles from "../../../../src/assets/styles/componentStyles/workflowAnalyticsStyles/interactionAndCampaigns.module.scss";
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { Moment } from 'moment';
import { flagShowGetStartedPage } from '../../../utils/constants';
import GlobalEmptyPage from '../../utility/globalEmptyPage/globalEmptyPage';
import IconsColor from '../../utility/iconsColor';
import GlobalRoundLoader from '../../utility/globalRoundLoader';
import GlobalPageHeaderText from '../../utility/globalPageHeaderText';
import { useDashboardAnalyticsData } from './useDashboardAnalyticsData';

const DashboardAnalytics = lazy(() => import("./dashboardAnalytics"));

export interface filterData {
    startDate: Moment | null;
    endDate: Moment | null;
}

const DashboardAnalyticsGlobal = () => {

    // flagLaptopScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1200px)'),

    const { smallScreen, desktopScreen } = useDashboardAnalyticsData();

    const { userDetail } = useContext(UserContext) as UserContextPayload; 

    const innerHeight = window.innerHeight - 110;

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={globalStyles.fullwidth}>
            {/* {flagLoading.flagRoundLoader && <RoundLoader />} */}
                <Grid container className={`${globalStyles.flexColumn} ${globalStyles.containerFlexWrap} ${interactionAndCampaignsStyles.analyticsMainContainer}`}>
                    <Grid item xs={12} sm={12}>
                        <Grid container className={`${globalStyles.alignItemCenter} ${globalStyles.flexColumn}`}>
                            <Grid
                                item
                                className={`${globalStyles.fullwidth} ${interactionAndCampaignsStyles.analyticsPageHeader}`}
                            >
                                <GlobalPageHeaderText mainHeadText="Dashboard" flagMainTextOnly />

                                {!(smallScreen) && (
                                    <Divider
                                        className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${interactionAndCampaignsStyles.analyticsPageHeaderDivider}`}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </Grid>  

                    {flagShowGetStartedPage(userDetail) ?  
                        <Grid item xs={12} 
                            className={`${!desktopScreen ? `${globalStyles.displayFlexStyle} ${globalStyles.alignItemCenter}` : ''} ${globalStyles.overflowAuto} ${interactionAndCampaignsStyles.analyticsPageContentGrid}`} 
                            sx={{ maxHeight: `${innerHeight}px !important`, minHeight: `${innerHeight}px !important`, height: `${innerHeight}px !important` }}
                        > 
                            <GlobalEmptyPage 
                                icon={<IconsColor iconName="emptyDashboardPageIcon" height={62} width={62} fillColor={'#111111'} />}
                                titleText={`It's quiet here. Launch your first chatbot or campaign to see performance insights.`}
                            />
                        </Grid>
                        :
                        <Grid item xs={12}>
                            <Suspense fallback={<GlobalRoundLoader />}>
                                <DashboardAnalytics />
                            </Suspense>
                        </Grid>
                    }

                </Grid>
            </Grid>
        </>
    )
}

export default DashboardAnalyticsGlobal
